import {Injectable} from '@angular/core';
import {HttpClient, HttpEventType, HttpHeaders, HttpParams, HttpRequest} from '@angular/common/http';
import {Observable, throwError} from 'rxjs';
import {catchError, map} from 'rxjs/operators';

import {TokenService} from '@app/core/security/token.service';
import {environment} from '@env/environment';
import {Claim} from '@app/views/common/dialog-announcement/announcement.service';

@Injectable()
export class UploadService {

    constructor(
        public httpClient: HttpClient,
        public tokenService: TokenService
    ) {
    }

    public uploadFile(file: File, uploadURL: string) {

        const token = this.tokenService.getToken();
        const headers = new HttpHeaders({
            // 'Content-Type': file.type,
            'X-Auth-Token': token
        });

        const params = new HttpParams();
        params.set('Content-Type', 'multipart/form-data');
        params.set('Client-Filename', file.name);
        params.set('Mime-Type', file.type);

        const data = new FormData();
        data.append('file', file);

        const req = new HttpRequest('POST', uploadURL, data,
            {
                headers: headers,
                withCredentials: false,
                reportProgress: false,
                params: params
            });

        return this.httpClient.request<any>(req).pipe(
            map(event => {
                switch (event.type) {
                    case HttpEventType.UploadProgress:
                        const progress = Math.round(100 * event.loaded / event.total);
                        return { status: 'progress', message: progress };

                    case HttpEventType.Response:
                        return event.body;
                    default:
                        return `Unhandled event: ${event.type}`;
                }
            })
        );
    }
}


@Injectable({
    providedIn: 'root'
})
export class AnnouncementUploadService extends UploadService {

    constructor (public httpClient: HttpClient,
                 public tokenService: TokenService) {
        super(httpClient, tokenService);
    }

    public uploadPdf(files: File[], applicationId: string = '') {
        const uploadUrl = `${environment.datahubBaseURI}/api/v2/vendorpolicies/uploadFile?applicationGuid=${applicationId}`;
        return super.uploadFile(files[0], uploadUrl);
    }

    public uploadUrl(externalUrl: string, applicationId: string = '') {
        const url = `${environment.datahubBaseURI}/api/v2/vendorpolicies/uploadUrl?applicationGuid=${applicationId}&privacyPolicyUrl=${externalUrl}`;
        return this.httpClient.post<any>(url, {})
            .pipe(catchError(() => throwError(new Error('Conversion of html file has failed'))));
    }

    public getDoc(applicationId: string = ''): Observable<Claim> {
        const url = `${environment.datahubBaseURI}/api/v2/vendorpolicies/uploaded?applicationGuid=${applicationId}`;
        return this.httpClient.get<any>(url);
    }
}


